<div class="auth-page">
  <div class="auth-card">
    <div class="auth-header">
      <img alt="Logo" class="auth-logo" src="assets/logo.png" routerLink="/dashboard">
      <h2 class="auth-title">{{'login.login'| translate}}</h2>
      <p class="auth-subtitle">Rezervační portál pro nabíjení EV</p>
    </div>
    <div class="auth-body">
      <form ngNativeValidate (ngSubmit)="loginPass()">
        <div class="form-group mb-3">
          <label class="form-label">{{'username'|translate}}</label>
          <s-input type="text" name="username" [(model)]="credentials.username" [required]="true"
            placeholder="Zadejte uživatelské jméno"></s-input>
        </div>
        <div class="form-group mb-4">
          <label class="form-label">{{'password'|translate}}</label>
          <s-input type="password" name="password" [(model)]="credentials.password" [required]="true"
            placeholder="Zadejte heslo"></s-input>
        </div>
        <div class="d-grid mb-3">
          <button class="btn btn-primary btn-lg" type="submit">
            <i class="bi bi-box-arrow-in-right me-2"></i>{{'login.sign_in'|translate}}
          </button>
        </div>
        <div class="text-center">
          <span class="text-muted">Nemáte účet?</span>
          <a routerLink="/register" class="ms-2 text-decoration-none fw-bold">Registrovat se</a>
        </div>
      </form>
    </div>
  </div>
</div>
